import React from 'react';
import { Mui } from '@osu/react-ui';

/**
 * SkipLinks Component
 * Provides keyboard navigation shortcuts for accessibility
 */
function SkipLinks() {
  const skipLinkStyle = {
    position: 'absolute',
    left: '-10000px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    '&:focus': {
      position: 'fixed',
      top: '10px',
      left: '10px',
      width: 'auto',
      height: 'auto',
      padding: '8px 16px',
      backgroundColor: 'primary.main',
      color: 'primary.contrastText',
      textDecoration: 'none',
      borderRadius: '4px',
      zIndex: 9999,
      fontSize: '14px',
      fontWeight: 'bold'
    }
  };

  return (
    <>
      <Mui.Link
        href="#main-content"
        sx={skipLinkStyle}
      >
        Skip to main content
      </Mui.Link>
      
      <Mui.Link
        href="#application-status"
        sx={skipLinkStyle}
      >
        Skip to application status
      </Mui.Link>
    </>
  );
}

export default SkipLinks;